module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"updateEntitySpendLimitCard.monthlySpendLimit.title":"Monthly Spend Limit"}}')
  delete Component.options._Ctor
}
